@if (displayRespondToRequestForm) {
  <h3>Respond to a request</h3>
}
<app-add-section-inline [title]="'Respond to request'" [btnTitle]="'Send'" (onIsAddNew)="updateDisplayRespondToRequestForm($event)"
  (onSave)="onSave($event)">
</app-add-section-inline>